// ======================================================================
// ERPDataGrid.jsx
// Reusable ERP Report Grid
// Used by: Inventory, Procurement, Costing, Reports
// ======================================================================

import React from "react";
import "./reportStyles.css";

/*
PROPS

columns = [
  { key:"material_name", label:"Material" },
  { key:"warehouse", label:"Warehouse" },
  { key:"qty", label:"Qty", align:"right" }
]

rows = []
loading = boolean
height = optional scroll height
*/

export default function ERPDataGrid({
  columns = [],
  rows = [],
  loading = false,
  height = "520px",
}) {

  // -------------------------------------------------------
  // CELL ALIGNMENT
  // -------------------------------------------------------
  const getAlign = (col) => {
    if (col.align === "right") return "text-right";
    if (col.align === "center") return "text-center";
    return "text-left";
  };

  // -------------------------------------------------------
  // UI
  // -------------------------------------------------------
  return (
    <div className="erp-report-card">

      {/* Scroll Container */}
      <div
        className="erp-grid"
        style={{
          maxHeight: height,
          overflowY: "auto",
          overflowX: "auto"
        }}
      >
         
        
        <table className="w-full table-auto text-sm">
          {/* ================= HEADER ================= */}
          <thead className="erp-table-head">
            <tr>
              {columns.map((col) => (
                <th
                  key={col.key}
                  className={`px-3 py-2 whitespace-nowrap ${getAlign(col)}`}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>

          {/* ================= BODY ================= */}
          <tbody>

            {/* Loading */}
            {loading && (
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center py-12 text-gray-500"
                >
                  Loading data...
                </td>
              </tr>
            )}

            {/* Empty */}
            {!loading && rows.length === 0 && (
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center py-14 text-gray-400"
                >
                  No records found
                </td>
              </tr>
            )}

            {/* Rows */}
            {!loading &&
              rows.map((row, index) => (
                <tr key={index} className="erp-row">

                  {columns.map((col) => (
                    <td
                      key={col.key}
                      className={`px-3 py-2 whitespace-nowrap ${getAlign(col)} ${
                        col.bold ? "font-medium" : ""
                      }`}
                    >
                      {col.render
                        ? col.render(row)
                        : row[col.key] ?? "-"}
                    </td>
                  ))}

                </tr>
              ))}

          </tbody>
        </table>
      </div>
    </div>
  );
}
